<acabim-datatable #dataTable [dataSources]="dataSources" hasDetailView="true">
</acabim-datatable>
